<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base">
                        <div class="flex">
                          <div  class="flex-1 p-2">
                            <label>{{$t('Labels.Company')}}</label>
                            <v-select :options="companies" v-model="license.company_uuid" :reduce="c => c.uuid" label="name"/>
                          </div>
                        </div>
                        <div class="flex">
                          <div  class="flex-1 p-2">
                            <label>{{$t('Labels.Start')}}</label>
                          <datepicker :disabled-dates="state.disabledDates" class="w-full" :value="license.begin_at" v-model="license.begin_at" name="start"></datepicker>
                          </div>
                          <div  class="flex-1 p-2">
                            <label>{{$t('Labels.Expire')}}</label>
                            <datepicker :disabled-dates="state.disabledDates" class="w-full" :value="license.expire_at" v-model="license.expire_at" name="expire"></datepicker>
                          </div>
                        </div>
                        <div class="text-right">
                          <vs-button @click="requestPassword()" class="bg-primary mt-4" type="filled" :disabled="!valid">{{$t("Labels.Save")}}</vs-button>
                        </div>
                    </vx-card>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    vSelect,
    Datepicker
  },

  data () {
    return {
      companies:[],
      license:{
        company_uuid: null,
        begin_at: Date(),
        expire_at: Date()
      },
      state: {
        disabledDates: {
          to: new Date() // Disable all dates up to specific date
        }
      }
    }
  },

  methods: {
    async getCompanies () {
      this.$vs.loading()
      const params = {
        url: 'companies',
        method: 'GET',
        params:{
          limit:10000,
          offset:0,
          byColumn:'name',
          byOrder:'asc'
        }
      }
      await request(params).then(response => {
        this.companies = response.data.data.rows
        this.companies.unshift({
          uuid: 0,
          name: this.$t('Labels.SelectOne')
        })
        this.license.company_uuid = 0
      }).finally(() => {
        this.$vs.loading.close()
      })                        
    },
    requestPassword () {
      globalPassActions.show()
    },
    async add () {
      const params = {
        url: 'licenses',
        method: 'POST',
        params: this.license
      }
      await request(params).then(response => {
        window.location.href = '/licenses/'
      })
    }
  },
  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Licenses')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Add')
    this.$route.meta.pageTitle = this.$t('Path.Add')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getCompanies()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    },
    valid () {
      const start = new Date(this.license.begin_at)
      const end = new Date(this.license.expire_at)
      if (this.license.company_uuid != 0 && end > start) return true
      else return false
    }
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.add()
    }
  }
}
</script>
